import React, { useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import Form from '../../../components/Reusable/Form/Form';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { numberOfItemsPerPage } from '../../../constants/globals.js';
import { config } from './SignetConfig';
import { findAllSignetFilterPageable } from '../../../actions/signet';
import '../../../styles/scss/app/SignetForm.scss';

const SignetFilter = ({
  t,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  findAllSignetFilterPageable,
  enums,
  pageSize,
}) => {
  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');
  const { fields } = config(t, enums);
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });
  const packConfig = () => {
    return { fields: [...fields] };
  };

  const packTranslations = () => {
    return { ...t };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);
    const postData = {
      tableName: 'signet',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          if (
            entry[0] === 'plannedStartFrom' ||
            entry[0] === 'plannedStartTo' ||
            entry[0] === 'submitDateFrom' ||
            entry[0] === 'submitDateTo'
          ) {
            if (
              values.plannedStartFrom !== initialValues.plannedStartFrom ||
              values.plannedStartTo !== initialValues.plannedStartTo
            )
              return {
                columnName: 'plannedStart',
                dateMin: values.plannedStartFrom,
                dateMax: values.plannedStartTo,
                logicalOperator: '><',
              };
            if (
              values.submitDateFrom !== initialValues.submitDateFrom ||
              values.submitDateTo !== initialValues.submitDateTo
            )
              return {
                columnName: 'requestForSignetApproval.submitDate',
                dateMin: values.submitDateFrom,
                dateMax: values.submitDateTo,
                logicalOperator: '><',
              };
          } else {
            if (entry[0].includes('signetState')) {
              return (
                (values.signetState?.value ||
                  values.signetState?.value === 0) && {
                  columnName: entry[0].substring(0, entry[0].indexOf('.')),
                  columnValue: values.signetState?.value,
                }
              );
            } else if (entry[0].includes('signetStatus')) {
              return (
                (values.signetStatus?.value ||
                  values.signetStatus?.value === 0) && {
                  columnName: entry[0].substring(0, entry[0].indexOf('.')),
                  columnValue: values.signetStatus?.value,
                }
              );
            } else if (entry[0].includes('requestForSignetApproval')) {
              return (
                entry[1] && {
                  columnName: 'requestForSignetApproval.referenceNumber',
                  columnValue: entry[1],
                }
              );
            } else {
              return (
                entry[1] && {
                  columnName: entry[0],
                  columnValue: entry[1],
                }
              );
            }
          }
          return null;
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllSignetFilterPageable(postData, pageSize, () =>
        saveFilters(values)
      );
    }
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className="SignetForm"
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    findAllSignetFilterPageable: (postData, pageSize, successCallback) => {
      dispatch(
        findAllSignetFilterPageable(0, pageSize, postData, successCallback)
      );
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(SignetFilter, 'SignetFilter'))
);
